import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import Confetti from 'react-confetti';
import { getUser } from 'src/utils/Common';

const CelebrationMessagePreview = ({ Message, openCelebrationPreviewDialog, setOpenCelebrationPreviewDialog }) => {
    const handleCloseCelebration = () => {
        setOpenCelebrationPreviewDialog(false);
    }
    const [dialogWidth, setDialogWidth] = React.useState(0);
    const [dialogHeight, setDialogHeight] = React.useState(0);
    const [userFullName, setUserFullName] = React.useState('');
    const [NewMessage, setNewMessage] = React.useState('');


    useEffect(() => {
        const user = getUser();
        setUserFullName(user.NameSurname);
        setNewMessage(Message.replace("@CalisanAdSoyad", userFullName));

        const dialog = document.getElementById('CelebrationPreviewDialog');

        if (dialog) {
            setDialogWidth(dialog.offsetWidth);
            setDialogHeight(dialog.offsetHeight);
        }
    });




    return (
        <div>

            <Dialog
                open={openCelebrationPreviewDialog}
                onClose={handleCloseCelebration}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent id="CelebrationPreviewDialog">
                    <Confetti
                        width={dialogWidth}
                        height={dialogHeight}
                    />
                    <div dangerouslySetInnerHTML={{ __html: NewMessage }} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseCelebration} color="primary">
                        Tamam
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default CelebrationMessagePreview;